import data from "@/../.sourceflow/dynamic_pages.json";

export const useDynamicPages = () => data;

export default useDynamicPages;
